import React from "react";
import {
    Box, MenuItem, Select, Typography, Stack, TextField, useTheme, useMediaQuery, Paper
} from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import PropTypes from "prop-types";

const FiltroTemporale = ({ filtro, setFiltro, startDate, setStartDate, endDate, setEndDate }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const today = new Date().toISOString().split('T')[0];

    return (
        <Paper 
            elevation={0}
            sx={{
                p: 2,
                borderRadius: "16px",
                backgroundColor: "#ffffff",
                border: "1px solid #e2e8f0",
                display: "flex",
                flexDirection: isMobile ? "column" : "row",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 2
            }}
        >
            <Stack direction="row" spacing={1.5} alignItems="center">
                <Box 
                    sx={{ 
                        p: 1, 
                        borderRadius: "10px", 
                        backgroundColor: "#f1f5f9", 
                        color: "#0b3d87",
                        display: "flex",
                        alignItems: "center"
                    }}
                >
                    <CalendarTodayIcon fontSize="small" />
                </Box>
                <Typography variant="subtitle2" sx={{ fontWeight: 700, color: "#1e293b" }}>
                    Periodo Analisi
                </Typography>
            </Stack>

            <Stack 
                direction={isMobile ? "column" : "row"} 
                spacing={2} 
                alignItems="center"
                sx={{ width: isMobile ? "100%" : "auto" }}
            >
                <Select
                    size="small"
                    value={filtro}
                    onChange={(e) => setFiltro(e.target.value)}
                    fullWidth={isMobile}
                    sx={{
                        fontSize: "13px",
                        height: "40px",
                        minWidth: isMobile ? "100%" : "180px",
                        backgroundColor: "#f8fafc",
                        borderRadius: "10px",
                        "& .MuiOutlinedInput-notchedOutline": { borderColor: "#e2e8f0" },
                        "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#cbd5e1" },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#0b3d87" }
                    }}
                >
                    <MenuItem value="mese_corrente">Mese Corrente</MenuItem>
                    <MenuItem value="ultimi_6_mesi">Ultimi 6 Mesi</MenuItem>
                    <MenuItem value="ultimo_anno">Ultimo Anno</MenuItem>
                    <MenuItem value="ultimi_3_anni">Ultimi 3 Anni</MenuItem>
                    <MenuItem value="custom">Personalizzato</MenuItem>
                </Select>

                {filtro === "custom" && (
                    <Stack direction="row" spacing={1} alignItems="center" sx={{ width: isMobile ? "100%" : "auto" }}>
                        <TextField
                            type="date"
                            size="small"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                            slotProps={{ htmlInput: { max: today } }}
                            sx={{ 
                                "& .MuiInputBase-input": { fontSize: "12px", py: "10px" },
                                width: isMobile ? "100%" : "140px",
                                backgroundColor: "#f8fafc",
                                borderRadius: "10px"
                            }}
                        />
                        <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 600 }}>AL</Typography>
                        <TextField
                            type="date"
                            size="small"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                            slotProps={{ htmlInput: { max: today } }}
                            sx={{ 
                                "& .MuiInputBase-input": { fontSize: "12px", py: "10px" },
                                width: isMobile ? "100%" : "140px",
                                backgroundColor: "#f8fafc",
                                borderRadius: "10px"
                            }}
                        />
                    </Stack>
                )}
            </Stack>
        </Paper>
    );
};

FiltroTemporale.propTypes = {
    filtro: PropTypes.string.isRequired,
    setFiltro: PropTypes.func.isRequired,
    startDate: PropTypes.string,
    setStartDate: PropTypes.func.isRequired,
    endDate: PropTypes.string,
    setEndDate: PropTypes.func.isRequired
};

export default FiltroTemporale;
 